<template>
  <nav class="nav-bar">
    <div class="nav-inner">
      <div class="nav-brand" @click="go('/')">
        <img src="/public/logo.png" class="nav-logo" />
        <span class="nav-name">云南信和科技</span>
      </div>
      <div class="nav-links" :class="{ open: menuOpen }">
        <span class="nav-link" :class="{ active: isActive('/') }" @click="go('/')">首页</span>
        <span class="nav-link" :class="{ active: isActive('/about') }" @click="go('/about')">关于信和</span>
        <span class="nav-link" :class="{ active: isActive('/join') }" @click="go('/join')">加入信和</span>
      </div>
      <div class="nav-hamburger" @click="menuOpen = !menuOpen">
        <span :class="{ open: menuOpen }"></span>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    name: 'NavBar',
    data() {
      return { menuOpen: false }
    },
    watch: {
      '$route'() { this.menuOpen = false }
    },
    methods: {
      go(path) {
        if (this.$route.path !== path) {
          this.$router.push(path)
        }
        this.menuOpen = false
      },
      isActive(path) {
        return this.$route.path === path
      }
    }
  }
</script>
<style lang="less">
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  background: rgba(255,255,255,0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(0,0,0,0.06);
  z-index: 1000;
  .nav-inner {
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
  }
  .nav-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    .nav-logo {
      height: 36px;
      width: auto;
    }
    .nav-name {
      font-size: 16px;
      font-weight: 600;
      color: #1a1a2e;
      letter-spacing: 1px;
    }
  }
  .nav-links {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .nav-link {
    color: #666;
    font-size: 14px;
    padding: 8px 18px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.25s;
    &:hover {
      color: #1a1a2e;
      background: rgba(0,0,0,0.04);
    }
    &.active {
      color: #32ADC6;
      background: rgba(50,173,198,0.08);
      font-weight: 500;
    }
  }
  .nav-hamburger {
    display: none;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span, span::before, span::after {
      display: block;
      width: 22px;
      height: 2px;
      background: #333;
      border-radius: 2px;
      transition: all 0.3s;
      position: relative;
    }
    span::before, span::after {
      content: '';
      position: absolute;
      left: 0;
    }
    span::before { top: -7px; }
    span::after { top: 7px; }
    span.open {
      background: transparent;
      &::before { top: 0; transform: rotate(45deg); }
      &::after { top: 0; transform: rotate(-45deg); }
    }
  }
}

@media (max-width: 768px) {
  .nav-bar {
    height: 56px;
    .nav-inner { padding: 0 16px; }
    .nav-brand {
      .nav-logo { height: 28px; }
      .nav-name { font-size: 14px; }
    }
    .nav-hamburger {
      display: flex;
    }
    .nav-links {
      position: fixed;
      top: 56px;
      left: 0;
      right: 0;
      background: rgba(255,255,255,0.98);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      flex-direction: column;
      padding: 8px 0;
      gap: 0;
      border-bottom: 1px solid rgba(0,0,0,0.06);
      box-shadow: 0 4px 16px rgba(0,0,0,0.06);
      transform: translateY(-100%);
      opacity: 0;
      pointer-events: none;
      transition: all 0.3s;
      &.open {
        transform: translateY(0);
        opacity: 1;
        pointer-events: all;
      }
      .nav-link {
        width: 100%;
        text-align: center;
        padding: 14px 0;
        font-size: 15px;
        border-radius: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue